export const timeTracking = {
  title: 'Time Tracker',
  selectTask: 'Select task',
  selectTaskPlaceholder: 'Select...',
  timerStarted: 'Timer started',
  timerStopped: 'Timer stopped',
  timerPaused: 'Timer paused',
  timerResumed: 'Timer resumed',
  start: 'Start',
  pause: 'Pause',
  resume: 'Resume',
  paused: 'Paused',
  totalTime: 'Total',
  hours: 'hours',
  
  // Timer controls
  startTimer: 'Start',
  stopTimer: 'Stop',
  placeholder: 'What are you working on? (optional)',
  
  // Time entries list
  timeEntries: 'Time Entries',
  addManual: 'Add Manual Entry',
  noEntries: 'No time entries yet',
  
  // Entry details
  billable: 'Billable',
  running: 'Running',
  edit: 'Edit',
  delete: 'Delete',
  
  // Form
  newEntry: 'New Time Entry',
  editEntry: 'Edit Time Entry',
  description: 'Description',
  descriptionPlaceholder: 'What did you do?',
  startTime: 'Start Time',
  endTime: 'End Time',
  duration: 'Duration',
  billableTime: 'Billable Time',
  dateLabel: 'Date',
  
  // Buttons
  cancel: 'Cancel',
  create: 'Create',
  update: 'Update',
  saving: 'Saving...',
  
  // Delete confirmation
  deleteTitle: 'Delete Time Entry',
  deleteMessage: 'Are you sure you want to delete this time entry?',
  deleteWarning: 'This action cannot be undone.',
  
  // Errors
  errorStartTimer: 'Failed to start timer',
  errorStopTimer: 'Failed to stop timer',
  errorDeleteEntry: 'Failed to delete time entry',
  errorLoadEntries: 'Failed to load time entries',
  errorAlreadyRunning: 'Already have a running timer for this task',
  
  // Validation
  startRequired: 'Start date and time are required',
  endRequired: 'End date and time are required',
  endAfterStart: 'End time must be after start time',
  maxDuration: 'Time entry cannot be longer than 24 hours',
};
